<template>
  <v-dialog scrollable persistent v-model="dialog" max-width="1300px">
    <template v-slot:activator="{ on }">
      <v-tooltip left v-on="on">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            dark
            small
            fab
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar checklist</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="closeForm">close</v-icon>
      </v-system-bar>

      <v-card-title class="mb-2 pb-0">
        <span class="title grey--text text--darken-2">
          {{ setTitleForm }}
        </span>
      </v-card-title>

      <v-card-text class="mt-0 pt-0">
        <JobFormDlg
          :showButton="false"
          :dialog="formJobDialog"
          :openForm="() => openDialogForm()"
          :closeForm="() => closeDialogForm()"
          :jobId="jobId"
          @newJob="addJob"
          :editFormData="editJobFormData"
          :editActivityIndex="editActivityIndex"
        />

        <ConfirmJobDlg
          :showButton="false"
          :dialog="formConfirmJobDialog"
          :openForm="() => openConfirmJobDialog()"
          :closeForm="() => closConfirmJobDialog()"
          :jobId="jobId"
          :jobIndex="jobIndex"
          @jobConcluded="addJobConcluded"
        />

        <v-form
          :key="render"
          style="min-height: 400px"
          ref="checklistForm"
          v-model="validForm"
          lazy-validation
          class="mt-0 pt-0"
        >
          <v-layout>
            <v-flex xs12>
              <v-menu
                v-model="startDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="start_date_formated"
                    label="Data inicio"
                    :disabled="true"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    return-masked-value
                    mask="##/##/####"
                    :rules="$store.state.formRules.required"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="formData.checklist.start_date"
                  @input="startDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex
              xs12
              v-for="(place, index) in formData.jobs"
              :key="index"
              style="margin-bottom: 2px solid black"
              class="mb-2"
            > 
              <v-card-text class="elevation-2">
                <p class="subheading grey--text text--darken-2 text-sm-left mb-0">
                  {{ place.name }}

                  <v-btn dark flat icon small color="primary" @click="openDialogForm(place.id)" v-if="!viewForm">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </p>

                <v-data-table
                  v-if="place.activities.length > 0"
                  :headers="tableHeader"
                  :items="place.activities"
                  rows-per-page-text="Linhas por página"
                  no-data-text="Não há dados"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td class="text-xs-left">
                      {{ props.item.start_date | moment("DD/MM/YYYY") }}
                    </td>

                    <td class="text-xs-left">
                      {{ props.item.description }}
                    </td>

                    <td class="text-xs-left">
                      {{ props.item.criticality_level }}
                    </td>

                    <td class="text-xs-left">
                      {{ props.item.service_type || "--" }}
                    </td>

                    <td class="text-xs-left">
                      {{ props.item.term | moment("DD/MM/YYYY") }}
                    </td>

                    <td class="text-xs-left">
                      <a
                        v-if="props.item.photo"
                        :href="props.item.photo"
                        target="blank"
                      >
                        Ver foto
                      </a>
                      <span v-else>--</span>
                    </td>

                    <!--<td class="text-xs-left">
                      {{ props.item.status }}
                    </td>-->

                    <td class="text-xs-left">
                      {{ props.item.end_date | moment("DD/MM/YYYY") }}
                    </td>

                    <td class="text-xs-left">
                      {{ props.item.description_solution || '--' }}
                    </td>

                    <td class="text-xs-center" v-if="!viewForm">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-if="props.item.end_date == null"
                            v-on="on"
                            small
                            class="mr-2"
                            @click="openConfirmJobDialog(place.id, props.index)"
                          >
                            check
                          </v-icon>
                        </template>
                        <span>Marcar solução</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-if="props.item.end_date == null"
                            v-on="on"
                            small
                            class="mr-2"
                            @click="editItem(props.item, place.id, props.index)"
                          >
                            edit
                          </v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>

                      <!--<v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            class="mr-2"
                            @click="openConfirmDeleteJob(place.id, props.index)"
                          >
                            delete
                          </v-icon>
                        </template>
                        <span>Remover solução</span>
                      </v-tooltip>-->
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions style="border-top: 1px solid #eee">
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="closeForm"
          >Cancelar</v-btn
        >
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as moment from 'moment'
import { getJobsDetails, getChecklists, saveNewJobs } from '@/services/checklists'
import JobFormDlg from './JobFormDlg.vue'
import ConfirmJobDlg from './ConfirmJobDlg.vue'

const defaultChecklistForm = () => {
  return {
    checklist: {
      id: null,
      start_date: new Date().toISOString().substr(0, 10),
    },
    jobs: [],
  }
}

export default {
  name: 'ChecklistFormDlg',

  components: {
    JobFormDlg,
    ConfirmJobDlg,
  },

  props: {
    dialog: Boolean,
    openForm: Function,
    closeForm: Function,
    editFormData: Object,
    condominiumId: Number,
  },

  data () {
    return {
      render: 0,
      startDate: false,
      formJobDialog: false,
      formConfirmJobDialog: false,
      jobId: null,
      jobIndex: null,
      valDate: false,
      viewForm: false,
      validForm: true,
      formData: defaultChecklistForm(),
      tableHeader:  [
        { text: 'Data início', align: 'left', sortable: false, value: 'start_date' },
        { text: 'Descrição', align: 'left', sortable: false, value: 'description' },
        { text: 'Criticidade', align: 'left', sortable: false, value: 'criticality_level' },
        { text: 'Tipo de serviço', align: 'left', sortable: false, value: 'service_type' },
        { text: 'Prazo', align: 'left', sortable: false, value: 'term' },
        { text: 'Foto', align: 'left', sortable: false, value: 'photo' },
        //{ text: 'Status', align: 'center', sortable: false, value: 'status' },
        { text: 'Data fim', sortable: false, value: 'end_date' },
        { text: 'Descrição solução', align: 'left', sortable: false, value: 'description_solution' },
        { text: 'Ações', sortable: false, align: 'center' }
      ],
      editJobFormData: null,
      editActivityIndex: null
    }
  },

  computed: {
    setTitleForm () {
      if (!this.editFormData) return 'Novo checklist'

      if (this.editFormData.view) return 'Visualização'

      return "Editar checklist"
    },

    start_date_formated: {
      get () {
        return this.formData.checklist.start_date
          ? moment(this.formData.checklist.start_date).format('DD/MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.formData.checklist.start_date = new Date().toISOString().substr(0, 10)
            return
          }
          this.formData.checklist.start_date = date
        } else {
          this.formData.checklist.start_date = ''
        }
      }
    },
  },

  watch: {
    dialog (edit) {   
      if (edit) {
        if (this.editFormData) {
          this.viewForm = this.editFormData.view

          this.getFullChecklist()

          this.$refs.checklistForm.resetValidation()
        } else {
          this.getAllChecklists()
        }
      } else {
        this.formData = defaultChecklistForm()
        this.viewForm = false
      }
    }
  },

  methods: {
    addJobConcluded(payload) {
      this.formData.jobs.every((place, index) => {
        if (place.id == payload.jobId) {
          this.formData.jobs[index].activities[payload.jobIndex] = {
            ...this.formData.jobs[index].activities[payload.jobIndex],
            ...payload.data
          }
          
          return false
        }
        
        return true
      })

      this.forceRender()
    },

    openConfirmJobDialog(placeId, index) {
      this.jobId = placeId
      this.jobIndex = index

      this.formConfirmJobDialog = true
    },

    openConfirmDeleteJob(placeId, index) {
      let obj = {
        message: `Você deseja remover a solução?`,
        title: `Excluir solução`,
        callback: (_) => {
          this.deleteSolution(placeId, index)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }

      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    deleteSolution(placeId, index) {
      console.log("Remova a solução do local: ", placeId)
      console.log("O indíce é: ", index)

      // Colocar end_date e description_solution para ""
    },

    closConfirmJobDialog () {
      this.formConfirmJobDialog = false
    },

    addJob(payload) {
      if(!payload.edit) {
        this.formData.jobs.every(place => {
          if (place.id == payload.id) {
            place.activities.push(payload.data)
            return false
          }
  
          return true
        })
      } else {
        this.formData.jobs.every((place, index) => {
          if (place.id == payload.id) {          
            this.formData.jobs[index].activities[payload.activityIndex] = {
              ...payload.data
            }
            
            return false
          }
          
          return true
        })
      }

      this.forceRender()
    },

    openDialogForm (placeId) {
      this.jobId = placeId

      this.formJobDialog = true
    },

    editItem(item, placeId, index) {
      this.editJobFormData = item
      this.editActivityIndex = index
      this.jobId = placeId

      this.formJobDialog = true
      //view === 'viewForm' ? (item.view = true) : (item.view = false)
      //this.formData = Object.assign({}, item)
      //this.frmCondominiumDialog = true
    },

    closeDialogForm () {
      this.editJobFormData = null
      this.formJobDialog = false
    },

    async getFullChecklist() {
      const response = await getJobsDetails(this.editFormData.id, this.editFormData.condominium_id)

      this.formData = response
    },

    async getAllChecklists() {
      const response = await getChecklists()

      response.map(checklist => {
        this.formData.jobs.push({
          id: checklist.id,
          name: checklist.name,
          activities: []
        })
      })
    },

    async doSave () {
      const response = await saveNewJobs(this.formData, this.condominiumId)

      console.log("Resposta do back: ", response)

      this.$refs.checklistForm.resetValidation()

      this.closeForm()
    },

    resetDialog () {
      this.dialogShow = !this.dialogShow
    },

    forceRender() {
      this.render++
    }
  }
}
</script>
